export default "__VITE_ASSET__D$mkXfC2__"